import { failureActionHandler } from 'store';
import injectReducer from 'store/injectReducer';
import * as types from './ActionTypes';
import { IIntegrationList, IOrganizationTypeList } from '../models';
import { IMainReducer } from './models';

export const InitialMainReducer: IMainReducer = {
	prevLocation: [],
	prevCrumbs: [],
	isNavbarOpened: false,
	organizationTypeList: [],
	integrationList: [],
	isLoading: false,
};

export default injectReducer(InitialMainReducer, {
	[types.GET_INTEGRATIONS.FAILURE]: failureActionHandler,
	[types.GET_ORGANISATION_TYPES.FAILURE]: failureActionHandler,

	[types.UPDATE_PREV_LOCATION]: (
		state: IMainReducer,
		{ payload }: { payload: IMainReducer['prevLocation'] },
	) => ({
		...state,
		prevLocation: payload,
	}),
	[types.UPDATE_PREV_CRUMBS]: (
		state: IMainReducer,
		{ payload }: { payload: IMainReducer['prevCrumbs'] },
	) => ({
		...state,
		prevCrumbs: payload,
	}),
	[types.TOGGLE_NAVBAR]: (
		state: IMainReducer,
		{ payload }: { payload: boolean },
	) => ({
		...state,
		isNavbarOpened: payload,
	}),

	[types.GET_INTEGRATIONS.SUCCESS]: (
		state: IMainReducer,
		{ payload }: { payload: IIntegrationList },
	): IMainReducer => ({
		...state,
		integrationList: payload,
		isLoading: false,
	}),

	[types.GET_ORGANISATION_TYPES.SUCCESS]: (
		state: IMainReducer,
		{ payload }: { payload: IOrganizationTypeList },
	): IMainReducer => ({
		...state,
		organizationTypeList: payload,
		isLoading: false,
	}),
});
